// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import '../theme/index.css'
import ElementUI from 'element-ui'
Vue.use(ElementUI);

import App from './App'
import router from './router'
import '../static/css/style.scss';

import common from '../static/js/common.js';
Vue.use(common);
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js